/**
 * Copilot Studio chat panel — wraps Direct Line Web Chat for the chatbot UI.
 */
import React from 'react';
import { Box } from '@mui/material';
import type { UseCopilotStudioResult } from '@hooks/useCopilotStudio';
import { CopilotStudioChat } from './CopilotStudioChat';

const DEFAULT_DIRECT_LINE_DOMAIN = 'https://europe.directline.botframework.com/v3/directline';

export interface CopilotChatPanelProps {
  copilot: UseCopilotStudioResult;
  onNewConversation?: () => void;
  isPanelVisible?: boolean;
}

export const CopilotChatPanel: React.FC<CopilotChatPanelProps> = ({
  copilot,
  onNewConversation,
  isPanelVisible,
}) => (
  <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
    <CopilotStudioChat
      token={copilot.token || ''}
      conversationId={copilot.conversationId || ''}
      directLineDomain={copilot.directLineDomain || DEFAULT_DIRECT_LINE_DOMAIN}
      conversationKey={String(copilot.sessionKey)}
      historyMessages={copilot.historyMessages}
      loading={copilot.loading}
      error={copilot.error}
      onNewConversation={onNewConversation}
      isPanelVisible={isPanelVisible}
    />
  </Box>
);
